import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

const defaultComponent = ({ record }) => <div>{JSON.stringify(record)}</div>

const empty = () => (
  <Fragment>
    <Heading small sup="Not found">
      Unable to display record
    </Heading>

    <p>We are unable to show you this record, possibly because of some filters you may have on.</p>
  </Fragment>
)

const ListItemDetail = ({ record, loading, base_url, component = defaultComponent }) => (
  <section className="listDetail">
    {loading ? null : React.createElement(record ? component : empty, { record, base_url })}
  </section>
)

export default ListItemDetail



// WEBPACK FOOTER //
// ./src/ui/list/views/detail.jsx